module.exports = __webpack_public_path__ + "img/morro-dos-anjos.3207d6c7.jpg";